











import { Vue, Prop, Component } from 'vue-property-decorator'
import { CookieInfo } from '../store/cookies/types'

@Component
export default class CookieConsentCookiesBlock extends Vue {
  @Prop() readonly cookie!: CookieInfo

  text (id: string) {
    return `${this.$t(`__COOKIE_${id.toUpperCase()}_TITLE`, 'privacy')}: ${this.$t(this.cookie[id], 'privacy')}`
  }
}
